import { SET_CARDS } from "../../actions/types/types";

const initState = {
  cards: [],
  tempPackageId: null,
  checkoutResponse: null,
  mobilePaymentStatus: null,
};

const CardReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_CARDS:
      return {
        ...state,
        cards: action.payload.data,
      };

    case "SET_CHECKOUT_RESPONSE": {
      return {
        ...state,
        checkoutResponse: action.payload.data,
      };
    }
    case "SET_TEMP_PACKAGE_ID": {
      return {
        ...state,
        tempPackageId: action.payload.data,
      };
    }
    case "SET_MOBILE_PAYMENT_STATUS": {
      return {
        ...state,
        mobilePaymentStatus: action.payload.data,
      };
    }
    default:
      return { ...state };
  }
};

export default CardReducer;
